import { specialistRegistrationReq } from "../../../redux/specialist-slices/auth.slice";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { specialistSignupSchema } from "../../../utils/velidations";
import InputField1 from "../../../components/ui/InputField1";
import ReCAPTCHA from "react-google-recaptcha";
import Icons from "../../../assets/js/Icons";
import { red } from "@mui/material/colors";
import { useDispatch } from "react-redux";
import { useState } from "react";

function Credentials({ handleChange }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState([]);
  const [show1, setShow1] = useState(false);
  const [password, setPassword] = useState({});

  // Handle validate phone number
  const validatePhone = (e) => {
    let value = e.target?.value;
    const allowedChars = /[^0-9+]/g;
    value = value.slice(0, 10);
    const filteredValue = value.replace(allowedChars, "");
    e.target.value = filteredValue;
  };

  // Handle create specialist
  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    const result = specialistSignupSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setErrors(groupedErrors);
      return;
    }
    setErrors([]);
    if (!Object.keys(err)?.length) {
      dispatch(specialistRegistrationReq(formData))
        .unwrap()
        .then(() => {
          handleChange("expertise");
        })
        .catch(() => { });
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        borderTop: "none",
        borderRadius: "0 0 6px 6px",
        border: "1px solid #3498db",
      }}
    >
      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Join Our Expert Community
      </Typography>
      <Typography mb={2} fontWeight="500" color="other.color2">
        Start by entering your basic information to create your specialist
        account.
      </Typography>
      <Stack spacing="20px" component="form" onSubmit={handleSubmit}>
        <Box>
          <InputField1 label="Name *" name="fullName" placeholder="Full Name" />
          {errors?.fullName && (
            <Typography mt={1} color={red["500"]}>
              {errors?.fullName?.[0]}
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="email"
            type="email"
            label="Email *"
            autoFocus="off"
            placeholder="Enter Your Email Address"
          />
          {errors?.email && (
            <Typography mt={1} color={red["500"]}>
              {errors?.email?.[0]}
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="phone"
            label="Phone *"
            onChangeFun={validatePhone}
            placeholder="Enter Your Phone Number"
          />
          {errors?.phone && (
            <Typography mt={1} color={red["500"]}>
              {errors?.phone?.[0]}
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="password"
            autoFocus="off"
            label="Password *"
            placeholder="Password"
            type={show ? "text" : "password"}
            endIcon={
              <IconButton
                size="small"
                onClick={() => {
                  setShow(!show);
                }}
              >
                {!show ? <Icons.ViewSolid /> : <Icons.ViewOffSolid />}
              </IconButton>
            }
            onFocus={() => {
              setPassword(true);
            }}
            onBlur={() => {
              setPassword(false);
            }}
          />
          {errors?.password && (
            <Typography mt={1} color={red["500"]}>
              {errors?.password?.[0]}
            </Typography>
          )}
          {password && (
            <Typography mt={0.5} fontSize="14px" color="warning.main">
              Password must be 8-16 characters long and include at least one
              uppercase letter, one lowercase letter, one digit, and one special
              character (!@#$%^&*).
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="confPassword"
            label="Confirm Password *"
            placeholder="Confirm Password"
            type={show1 ? "text" : "password"}
            endIcon={
              <IconButton
                size="small"
                onClick={() => {
                  setShow1(!show1);
                }}
              >
                {!show1 ? <Icons.ViewSolid /> : <Icons.ViewOffSolid />}
              </IconButton>
            }
          />
          {errors?.confPassword && (
            <Typography mt={1} color={red["500"]}>
              {errors?.confPassword?.[0]}
            </Typography>
          )}
        </Box>
        <Box>
          <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_KEY} />
          {errors?.["g-recaptcha-response"] && (
            <Typography mt={1} color={red["500"]}>
              Please verify the ReCaptcha
            </Typography>
          )}
        </Box>
        <Stack spacing={2} direction="row">
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
          >
            Next
          </Button>
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
          >
            Save
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Credentials;
